import { useState, useEffect } from "react";
import { useQuantityContext } from "../../QuantityContext";
import digilockerImage from "../../../Assets/img/icons/digi.svg";
import axios from "axios";
import { useSelector } from "react-redux";
import { setDigilockerData } from "../../../Redux/Reducers/KycReducer";
import { useDispatch } from "react-redux";

function DigilockerButton({ doc, onKycComplete, setDigilocker }) {
  const dispatch= useDispatch()
  const { openSnackbar, handleFailure } = useQuantityContext();
  const [verified, setVerified] = useState(false);
  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [disable, setDisable] = useState(false);
  const [kycCompleted, setKycCompleted] = useState(false);
  const navurl = new URL(window.location.href);
  const code = navurl.searchParams.get("code");
  const state = navurl.searchParams.get("state");

  const getUrl = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/digilocker/url`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
            // "ngrok-skip-browser-warning": "69420"
          },
        }
      );
      const data = response;
      console.log("Locker data digi", response);

      if (response?.data?.statusCode === 1000) {
        setKycCompleted(true);
        setDisable(true);

        setLoading(false);

        onKycComplete(response?.data?.data?.verified[doc]);
        // onKycComplete(data.data.verified[doc]);
        return;
      } else if (response?.data?.statusCode === 200) {
        setLoading(false);
        onKycComplete(response?.data?.data?.verified[doc]);
        setUrl(response?.data?.data?.url);
        // setVerified(response?.data?.data?.verified[doc] !== null);
      }
    } catch (error) {
      openSnackbar("Error in Digilocker URL", "error");
    }
  };

  const handleClick = () => {
    window.location.href = url;
  };

  const postToken = async (code, state) => {
    const token = localStorage.getItem("objectId");

    console.log("CODE AND STATE", code, "STATE", state);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/digilocker/token`,
        {
          code,
          state,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            // "ngrok-skip-browser-warning": "69420"
          },
        }
      );

      const postData = response.data;

      // pass data to parent component
      console.log("KYC RESPONSE", response);

      if (response?.data?.statusCode === 200) {
        openSnackbar("KYC Completed");
        console.log("Verified Data", response?.data?.data?.user);

        setDigilocker(() => ({
          digilockerid: response?.data?.data?.user?.digilockerid,
          reference_key: response?.data?.data?.user?.reference_key,
        }));
        dispatch(setDigilockerData({
          digilockerid: response?.data?.data?.user?.digilockerid,
          reference_key: response?.data?.data?.user?.reference_key,
        }));

        window.history.pushState({}, document.title, window.location.pathname);
        setKycCompleted(true);
        setDisable(true);

        setVerified(true);
        getUrl();
      }
    } catch (error) {
      console.error("Axios error:", error);
      if (error?.response?.data?.statusCode === 409 && error?.response?.data?.response === "Duplicacy with digilocker data with another account") {
        handleFailure("This ID has already been verified with another Neoin account. Please log in using your own Neoin account to continue verification.");
      }

      // if (error?.response?.data?.statusCode === 400 && error?.response?.data?.error === "Cannot read properties of undefined (reading 'code_verifier')") {
      //   handleFailure("Please Upload the Document in the Digilocker or Error in Digilocker Token")
      // }
      // openSnackbar("");
      setDisable(false);
    }
  };
  
  useEffect(() => {
    if (code && state) {
      postToken(code, state);
    };
  }, [code, state])

  useEffect(() => {
    // const navurl = new URL(window.location.href);
    // const code = navurl.searchParams.get("code");
    // const state = navurl.searchParams.get("state");
    // if (code && state) {

    // } else {
    console.log("Useeffcet code and state", code, "state", state);
    getUrl();
    // setDisable(true);
    // postToken(code, state);
    // }
  }, []);

  return (
    <>
      {loading ? (
        <h2></h2>
      ) : (
        <button
          style={{
            backgroundColor: "rgba(103, 62, 253, 0.9)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            fontSize: "16px",
            color: "white",
            padding: "15px 30px",
            borderRadius: "5px",
            marginTop: "20px",
          }}
          onClick={handleClick}
          disabled={disable || kycCompleted}
        >
          <img
            src={digilockerImage}
            alt="digilockerImage"
            style={{ width: "30px", height: "30px" }}
          />
          {/* {!verified ? disable ? kycCompleted ? "KYC Completed" : "Processing Request" : "Verify with Digilocker" : "KYC Completed"} */}
          {
            verified
              ? "KYC Completed"
              : disable
                ? kycCompleted
                  ? "Verify with Digilocker"
                  : "Processing Request"
                : "Verify with Digilocker"
          }
        </button>
      )}
    </>
  );
}

export default DigilockerButton;
